(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/configs/assets/javascripts/content-config.js') >= 0) return;  svs.modules.push('/components/sportinfo/configs/assets/javascripts/content-config.js');
"use strict";


const MatchState = svs.components.sportinfo.common.matchState.SportinfoMatchState;
const SportTypes = svs.components.sport.sportTypes.SportTypes;
const _svs$components$sport = svs.components.sportinfo.configs.sportConfigs,
  fallbackConfig = _svs$components$sport.fallbackConfig,
  _svs$components$sport2 = _svs$components$sport.sportTypeOverrides,
  trottingConfig = _svs$components$sport2.trottingConfig,
  soccerConfig = _svs$components$sport2.soccerConfig,
  tennisConfig = _svs$components$sport2.tennisConfig,
  handballConfig = _svs$components$sport2.handballConfig,
  iceHockeyConfig = _svs$components$sport2.iceHockeyConfig,
  basketballConfig = _svs$components$sport2.basketballConfig,
  _svs$components$sport3 = _svs$components$sport.productOverrides,
  fulltraffConfig = _svs$components$sport3.fulltraffConfig,
  maltipsetConfig = _svs$components$sport3.maltipsetConfig,
  sweHockeyConfig = _svs$components$sport.providerOverrides.sweHockeyConfig;
const productIds = svs.utils.products.productIds;
const logger = svs.core.log.getLogger('sportinfo:content-config');
const getSportTypeConfig = sportType => {
  switch (sportType) {
    case SportTypes.Soccer:
      return soccerConfig;
    case SportTypes.Hockey:
      return iceHockeyConfig;
    case SportTypes.Basketball:
      return basketballConfig;
    case SportTypes.Handball:
      return handballConfig;
    case SportTypes.Tennis:
    case SportTypes.AmericanFootball:
      return tennisConfig;
    case SportTypes.Trotting:
      return trottingConfig;
    default:
      return null;
  }
};

const getProductConfig = productId => {
  switch (productId) {
    case productIds.FULLTRAFF:
      return fulltraffConfig;
    case productIds.MALTIPSET:
      return maltipsetConfig;
    default:
      return null;
  }
};
const getConfigForProductOrSportType = (productId, sportType, providerIds) => {
  if (providerIds !== null && providerIds !== void 0 && providerIds.SweHockey) {
    return sweHockeyConfig;
  }
  if (productId) {
    const productConfig = getProductConfig(productId);
    if (productConfig) {
      return productConfig;
    }
  }
  if (sportType) {
    const sportTypeConfig = getSportTypeConfig(sportType);
    if (sportTypeConfig) {
      return sportTypeConfig;
    }
  }
  return fallbackConfig;
};

const getContentForMatchState = (content, matchState) => Object.keys(content).reduce((acc, menuItemName) => {
  if (content[menuItemName][matchState]) {
    acc[menuItemName] = content[menuItemName][matchState];
  }
  return acc;
}, {});
const getContent = _ref => {
  let sportType = _ref.sportType,
    _ref$matchState = _ref.matchState,
    matchState = _ref$matchState === void 0 ? MatchState.NotStarted : _ref$matchState,
    productId = _ref.productId,
    providerIds = _ref.providerIds;
  const config = getConfigForProductOrSportType(productId, sportType, providerIds);
  return getContentForMatchState(config.content, matchState);
};
const getMenuConfig = _ref2 => {
  let sportType = _ref2.sportType,
    productId = _ref2.productId,
    providerIds = _ref2.providerIds,
    _ref2$matchState = _ref2.matchState,
    matchState = _ref2$matchState === void 0 ? MatchState.NotStarted : _ref2$matchState;
  const config = getConfigForProductOrSportType(productId, sportType, providerIds);
  const filteredMenuItems = [];
  const menuConfig = config.menuItems[matchState];
  filteredMenuItems.push(...menuConfig);
  logger.debug('### Used config: ', config.config);
  return filteredMenuItems;
};
const getDefaultRoute = _ref3 => {
  var _defaultRoutes$matchS;
  let sportType = _ref3.sportType,
    productId = _ref3.productId,
    providerIds = _ref3.providerIds,
    matchState = _ref3.matchState;
  const _getConfigForProductO = getConfigForProductOrSportType(productId, sportType, providerIds),
    defaultRoutes = _getConfigForProductO.defaultRoutes;
  if (!defaultRoutes) {
    return undefined;
  }
  return (_defaultRoutes$matchS = defaultRoutes[matchState]) !== null && _defaultRoutes$matchS !== void 0 ? _defaultRoutes$matchS : undefined;
};
setGlobal('svs.components.sportinfo.configs.ContentConfig', {
  getMenuConfig,
  getContent,
  getDefaultRoute
});

 })(window);